import React from 'react';
import '../styles/Header.css'



const Header = () => {

    
    return (
        
        <div className='header' >

           <h3>Home Tutor</h3>
        
        </div>
        
    );
};

export default Header;